// extracted by mini-css-extract-plugin
module.exports = {"type":"DeckSummaryPanel_type__RfYqV"};